export default __webpack_public_path__ + "static/media/login-bg-mobile.a8e0bae6.png";